// What you missed.
//
// The counterpart to `ops/events.ts`: a short, timestamped list of what
// the runs have said since this console was opened, newest first. It is
// deliberately not a toast — see that file for why — and deliberately
// short, because anything older than the last few minutes is History's
// job and pretending otherwise would build a second, worse History here.

import { Panel } from "./Bits";
import type { RunEvent } from "../ops/events";
import { clockWords } from "../ops/words";

export function Feed({
  events,
  onPick
}: {
  events: RunEvent[];
  onPick(jobId: string): void;
}): JSX.Element | null {
  if (!events.length) return null;
  return (
    <Panel eyebrow="What just happened">
      <ul className="feed">
        {events.map(event => (
          <li key={event.id} className={`feeditem feeditem--${event.tone}`}>
            <button type="button" className="feeditem__hit" onClick={() => onPick(event.jobId)}>
              <span className="feeditem__dot" aria-hidden="true" />
              <span className="feeditem__what">
                <span className="feeditem__who">{event.who}</span> {event.what}
              </span>
              <time className="feeditem__at wf-numeric">{clockWords(event.atUnixSeconds)}</time>
            </button>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
